import { CalendarIcon, ImageIcon, LayersIcon } from '@radix-ui/react-icons';
import { Flex, Text } from '@raystack/apsara';

import { Show } from '@src/hoc';

import styles from './styles.module.css';

export const AssetTextWrapper = ({ title, date, asset }) => {
  return (
    <Flex direction='column' align='start' gap='small'>
      <Flex gap='small' align='center'>
        <LayersIcon color='var(--rs-color-foreground-base-secondary)' />
        <Text size={2} weight={400}>
          {title}
        </Text>
      </Flex>

      <Flex>
        <Flex gap='small' align='center'>
          <CalendarIcon color='var(--rs-color-foreground-base-secondary)' />
          <Text size={2} weight={400}>
            {date || 'NA'}
          </Text>
        </Flex>
        <Show when={asset?.length > 0}>
          <Flex gap='small' align='center' className={styles.assetWrapper}>
            <ImageIcon color='var(--rs-color-foreground-base-secondary)' />
            <Text size={2} weight={400}>
              {asset}
            </Text>
          </Flex>
        </Show>
      </Flex>
    </Flex>
  );
};
